import i18n from '@/i18n';
import 'whatwg-fetch'; //https://www.npmjs.com/package/whatwg-fetch
import Cookies from 'js-cookie';
import { v1 as uuidV1 } from 'uuid';
import qs from 'querystringify';
import getApi from './config';
import { sessionOrLocal, clearCookies } from '../tools/utils';
// import { Message } from 'vhall-ui';

/**
 * 错误码提示 统一在次处理
 * extendsMsg：增加扩展字段处理自定义错误信息 格式如：{510000: '错误信息'}，空位此处错误不需提示
 * 200
 * 600 对应 10000 参数错误
 * 其余错误信息 510000 - 516999，通过errorMap引入
 */
export default function fetchData(url, data1 = {}, header = {}, extendsMsg = {}) {
  const config = getApi(url);
  let [api, method, mock, paas, staticdata] = config;
  if (!api) throw TypeError(`${i18n.t('ai.k_001001')}`);
  const token = sessionOrLocal.get('token', 'localStorage') || '';
  let data = Object.assign(data1);
  // const interact_token = sessionStorage.getItem('interact_token') || null;
  let formData = null;
  if (method === 'GET' && data) {
    let Uri;
    api.indexOf('?') > -1 ? (Uri = '&') : (Uri = '?');
    Object.keys(data).forEach((key, indx) => {
      if (indx === data.length) {
        Uri = Uri + `${key}=${data[key]}`;
      } else {
        if (indx < Object.keys(data).length - 1) {
          Uri = Uri + `${key}=${data[key]}&`;
        } else {
          Uri = Uri + `${key}=${data[key]}`;
        }
      }
    });
    api = api + Uri;
  }
  let headers = {
    platform: sessionOrLocal.get('platform', 'localStorage') || 17,
    token: token,
    origin: window.location.origin,
    'request-id': uuidV1(),
    zone: Intl.DateTimeFormat().resolvedOptions().timeZone
  };
  // header 可能传gray-id，可能传递token，可能传递Content-Type
  if (header['token'] !== null && header['token'] !== undefined) {
    headers['token'] = header['token'];
  }
  // 若head里面存在，以head传入的灰度ID为准
  if (header['gray-id'] > 0) {
    headers['gray-id'] = header['gray-id'];
  } else if (window.sessionStorage.getItem('userId')) {
    headers['gray-id'] = window.sessionStorage.getItem('userId');
  } else if (Cookies.get('gray-id')) {
    headers['gray-id'] = Cookies.get('gray-id');
  }
  // 若选择发起传入了
  if (window.location.href.indexOf('/chooseWay') !== -1) {
    // pc观看等
    headers.platform = header.platform || sessionOrLocal.get('platform', 'localStorage') || 17;
  }
  // interact_token && (headers['interact-token'] = interact_token)
  if (
    window.location.hash.indexOf('/live/watch/') !== -1 ||
    window.location.pathname.indexOf('/cMiddle/') !== -1
  ) {
    // pc观看等
    headers.platform = 7;
  }
  // 针对微吼云  通过审核接口  单独进行修改传参类型--- 勿删
  if (header['Content-Type'] === 'multipart/form-data' || api.indexOf('apply-message-send') != -1) {
    formData = new FormData();
    for (let key in data) {
      if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
        formData.append(key, data[key]);
      }
    }
  } else if (header['Content-Type'] === 'application/json') {
    headers['Content-Type'] = 'application/json';
  } else {
    headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  let option = {
    method,
    // *GET, POST, PUT, DELETE, etc.
    mode: 'cors',
    // credentials: 'include',
    // include: cookie既可以同域发送，也可以跨域发送, *same-origin: 表示cookie只能同域发送，不能跨域发送 omit: 默认值，忽略cookie的发送
    headers: headers
  };
  if (method === 'POST' && header['Content-Type'] !== 'application/json') {
    option.body = formData || qs.stringify(data); // body data type must match "Content-Type" header
  } else if (method === 'POST' && header['Content-Type'] === 'application/json') {
    option.body = JSON.stringify(data);
  }
  if (mock) {
    api = `/mock${api}`;
  } else if (paas || staticdata) {
    api = `${process.env.VUE_APP_STATIC_URL}${api}`;
    option.headers = {};
  } else {
    api = `${process.env.VUE_APP_BASE_URL}${api}`;
  }
  // 对跨域携带cookie进行处理
  if (header.credentials) {
    option.credentials = 'include';
  }
  return fetch(api, option)
    .then(res => {
      return res.json();
    })
    .then(res => {
      if (res.code) {
        const errorKey = `errorMap[${res.code}]`;
        let msg = extendsMsg?.[res.code] || (i18n.te(errorKey) ? i18n.t(errorKey) : '');
        res.message = msg || res.msg;
        if (msg) {
          res.msg = msg;
        }
      }
      if (res.code === 404 || res.code === 403) {
        sessionStorage.setItem('errorReturn', this.$route.path);
        this.$router.push({
          path: '/warning/error'
        });
        return;
      } else if (res.code === 510015) {
        this.$router.push({
          path: '/upgrading'
        });
        return Promise.reject({
          code: 510015,
          msg: `${i18n.t('ai.k_001002')}`
        });
      } else if (res.code == 200) {
        return res;
      } else if (api.includes(process.env.VUE_APP_STATIC_URL)) {
        return res;
      } else {
        // token过期处理
        if (res.code == 511006) {
          sessionOrLocal.clear();
          sessionOrLocal.clear('localStorage');
          clearCookies(); // 清空缓存 - cookies缓存
        }
        return Promise.reject(res);
      }
    });
}
export const fetchPure = function (url, options) {
  return fetch(url, options);
};
